<template>
  <div class="contact">
    <header>
      <div class="navbar-fixed">
      <nav>
        <div class="nav-wrapper">
          <div class="row">
            <div class="col s12">
              <a href="#" data-target="sidenav-1" class="left sidenav-trigger hide-on-medium-and-up">
                <i class="material-icons">menu</i>
              </a>
              <h5 class="headerTitle desktopHeader">Assam Power Distribution Company Limited</h5>
              <h5 class="mobileHeader">Assam Power Distribution Company Limited</h5>
            </div>
          </div>
        </div>
      </nav>
    </div>
    </header>
    <div class="row positioning">
      <span class="fontstyle">Create New Contact</span>
    </div>
    <div class="divider" style="margin-top: -19px;"></div>

        </li>
      <li><router-link class="textAlign" to="/news">
        <i class="material-icons iconShift">speaker_notes</i>News</router-link></li>
      <li><router-link class="textAlign" to="/career">
        <i class="material-icons iconShift">portrait</i>Career</router-link></li>

        <div class="footer-fixed">
          <footer class="footerstyle">
            <div class="footer-copyright">
              <div class="container" style="font-size:11px; text-align:center;">
              © 2020 Copyright Assam Power Distribution Company Limited, Developed by IT Cell, APDCL.
              </div>
            </div>
          </footer>
        </div>
    </ul>

    <main>
      <form id="form-add-contact">
        <!-- succes modal -->
        <div id="successModal" class="modal" >
          <div class="modal-content" style="background-color:#e8f5e9  ;">
            <h4>Create New Contact</h4>
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
              <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
              <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
            </svg>
            <p class="success">Successfully Created !</p>
          </div>
          <div class="modal-footer" style="margin-top: -7rem; background-color:#e8f5e9  ;">
            <a href="#!" class="modal-close waves-effect waves-green btn green">OK</a>
          </div>
        </div>
        <!-- error modal -->
        <div id="errorModal" class="modal">
          <div class="modal-content"  style="background-color:#ffebee;">
            <h4>Create New Contact</h4>
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
              <circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
              <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3"/>
              <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2"/>
            </svg>
            <p class="error">Contact Creation Failed !</p>
          </div>
          <div class="modal-footer" style="margin-top: -7rem; background-color:#ffebee;">
            <a href="#!" class="modal-close waves-effect waves-red btn red">OK</a>
          </div>
        </div>
      <div class="row">
        <div class="col s12 m2 l2 xl2 paddingTop left">
          <h6>Office Type: </h6>
        </div>
        <div class="input-field col s12 m3 l3 xl3">
          <select id="officeType" class="browser-default" name="officeType" style="background-color: #fafafa;" @change="selectOffice()">
            <option value="" disabled selected>Choose your option</option>
            <!-- <option value="hq">Headquarter</option> -->
            <option value="z">Zone</option>
            <option value="c">Circle</option>
            <option value="d">Division</option>
            <option value="sd">Sub-Division</option>
          </select>
        </div>
        <div class="col s12 m2 l2 xl2 offset-m1 offset-l1 offset-xl1 paddingTop left">
          <h6>Office Name: </h6>
        </div>
        <div class="input-field col s12 m3 l3 xl3">
          <select id="officeName" class="browser-default" name="officeName" style="background-color: #fafafa;">
            <option value="" disabled selected>Choose your option</option>

          </select>
        </div>
      </div>
      <!-- New Row -->
      <div class="row">
        <div class="col s12 m2 l2 xl2 paddingTop left">
          <h6>Contact Person: </h6>
        </div>
        <div class="input-field col s12 m3 l3 xl3">
          <input id="contactPerson" type="text" class="validate" name="contactPerson" placeholder="Enter contact person">
          <!-- <label for="tenderDate">Enter tender date</label> -->
        </div>
        <div class="col s12 m2 l2 xl2 offset-m1 offset-l1 offset-xl1 paddingTop left">
          <h6>Designation: </h6>
        </div>
        <div class="input-field col s12 m3 l3 xl3">
          <input id="designation" type="text" class="validate" name="designation" placeholder="Enter designation">
          <!-- <label for="bidStartDate">Enter bid start date</label> -->
        </div>
      </div>
      <!-- New Row -->
      <div class="row">
        <div class="col s12 m2 l2 xl2 paddingTop left">
          <h6>Email: </h6>
        </div>
        <div class="input-field col s12 m3 l3 xl3">
          <input id="email" type="text" class="validate" name="email" placeholder="Enter email-id">
        </div>
        <div class="col s12 m2 l2 xl2 offset-m1 offset-l1 offset-xl1 paddingTop left">
          <h6>Mobile Number: </h6>
        </div>
        <div class="input-field col s12 m3 l3 xl3">
          <input id="mobile" type="text" class="validate" name="mobileNo" placeholder="Enter mobile number">
          <!-- <label for="bidOpenDate">Enter bid open date</label> -->
        </div>
      </div>
      <!-- New Row -->
      <div class="row">
        <div class="col s3 m3 l3 xl3 offset-s2 offset-m3 offset-l3 offset-xl3">
          <button class="btn" style="background-color: #43a047;" @click="addContact($event)" name="actionSubmit">SUBMIT
            <i class="material-icons right">send</i>
          </button>
        </div>
        <div class="col s3 m3 l3 xl3 offset-s1">
          <button class="btn" style="background-color: #ff9800;" type="submit" name="actionReset">Reset
            <i class="material-icons right">loop</i>
          </button>
        </div>
      </div>
    </form>
    </main>
  </div>
</template>

<script>
import axios from 'axios';
import 'materialize-css/dist/css/materialize.min.css';
import 'material-design-icons/iconfont/material-icons.css';
import M from 'materialize-css';
//const urlCommon = "http://localhost:8081/website";
//const urlCommon = "https://apdclrms.com/website";
const urlCommon = "https://www.apdcl.org/website";

export default{
  mounted(){

    M.AutoInit();

    var elems = document.querySelectorAll('.sidenav');
    var instances = M.Sidenav.init(elems, {});
    var drops = document.querySelectorAll('.dropdown-trigger');
    var instances = M.Dropdown.init(drops, {});
    var collaps = document.querySelectorAll('.collapsible');
    var instances = M.Collapsible.init(collaps, {});


  },
  methods:{
    arrowShowHide(x,y){
       var d = document.getElementById(x);
       var u = document.getElementById(y);
       if (d.style.display === "none") {
         d.style.display = "block";
         u.style.display = "none";
       } else {
         d.style.display = "none";
         u.style.display = "block";
       }
    },
    selectOffice(){
      var  val = document.getElementById("officeType").value;
      var officeName = document.getElementById("officeName");
    //  alert(selected.value);
      var zones = ['Bongaigaon zone', 'Dibrugarh Zone', 'Guwahati Zone', 'Jorhat Zone', 'Nagaon zone', 'Rangia zone', 'Silchar Zone', 'Tezpur Zone'];
      var circles = ['Badarpur', 'Barpeta', 'Bongaigaon', 'Cachar', 'Dibrugarh', 'GEC-I', 'GEC-II', 'Golaghat', 'Jorhat', 'KANCH', 'Kokrajhar',
       'Mangaldoi', 'Morigaon', 'Nagaon', 'North Lakhimpur', 'Rangia', 'Sivasagar', 'Tezpur', 'Tinsukia'];
      var divisions = ['Barpeta', 'B. Chariali', 'Bongaigaon', 'Chilapathar', 'Dhekiajuli', 'Dhemaji', 'Dhubri', 'Dibrugarh', 'Diphu', 'Duliajan', 'Digboi',
      'GED(C)', 'GED(E)', 'GED(N)', 'GED(S)', 'GED(W)', 'Goalpara', 'Golaghat', 'Haflong', 'Hailakandi', 'Hojai', 'Howraghat', 'Jagiroad', 'Jorhat-I',
      'Jorhat-II', 'Karimganj', 'Kokrajhar', 'Mangaldoi', 'Mirza', 'Moran', 'Morigaon', 'Nagaon-I', 'Nagaon-II', 'Nalbari', 'Nazira', 'North Lakhimpur',
      'Pathsala', 'Rangia', 'Silchar-I', 'Silchar-II', 'Sivasagar', 'Teok', 'Tezpur', 'Tinsukia', 'Udalguri'];
      var subdivisions = ['Moran ESD', 'Tezpur ESD(II)'];



      switch(val){
        case 'z':
        officeName.options.length = 0;
        for(var i=0;i<zones.length;i++){
        //  createOption(officeName, zones[i],zones[i]);
        var opt = document.createElement('option');
        opt.value = zones[i];
        opt.text = zones[i];
        officeName.options.add(opt);
        }
        break;
        case 'c':
        officeName.options.length = 0;
        for(var i=0; i<circles.length;i++){
          var opt = document.createElement('option');
          opt.value = circles[i];
          opt.text = circles[i];
          officeName.options.add(opt);
        }
        break;
        case 'd':
        officeName.options.length = 0;
        for(var i=0; i<divisions.length; i++){
          var opt = document.createElement('option');
          opt.value = divisions[i];
          opt.text = divisions[i];
          officeName.options.add(opt);
        }
        break;

        case 'sd':
        officeName.options.length = 0;
        for(var i=0; i<divisions.length; i++){
          var opt = document.createElement('option');
          opt.value = subdivisions[i];
          opt.text = subdivisions[i];
          officeName.options.add(opt);
        }
        break;

        default:
          officeName.options.length = 0;
          break;
      }

    },
    addContact(event){
      event.stopPropagation()
      event.preventDefault()

      // TODO: add validataion and return method

      var dataToSend = {
        "officeType": document.getElementById("officeType").value,
        "officeName":document.getElementById("officeName").value,
        "contactPerson":document.getElementById("contactPerson").value,
        "designation":document.getElementById("designation").value,
        "email":document.getElementById("email").value,
        "mobileNo":document.getElementById("mobile").value,
      }

      console.log(dataToSend)
      // TODO: add loader

      axios.post(urlCommon + "/api/admin/addcontact", dataToSend).then(function(response) {
        console.log(response)

        if (response.data == "success") {
          document.getElementById("form-add-contact").reset()
          var elems = document.getElementById('successModal');
          var instance = M.Modal.init(elems);
          instance.open();
        } else {
          document.getElementById("form-add-contact").reset()
          var elems = document.getElementById('errorModal');
          var instance = M.Modal.init(elems);
          instance.open();
        }
      })


    }
  }
}

</script>



<style scoped="true">

  .modal{
    overflow-y:hidden !important;
  }

  /* header, footer {
    padding-left: 300px;
  } */
  main{
    padding-left: 350px;
  }

  .sideGradient{
    /* background-color: #4158D0; */
    background-color: #3f51b5;
    background-image: linear-gradient(43deg, #4158D0 0%, #C850C0 46%, #FFCC70 100%);
  }
  .headerTitle{
    padding-left: 250px;
  }
  .mobileHeader{
    display: none;
    text-align: left;
  }
  .desktopHeader{
    display:block;
  }

  .positioning{
    margin-top: 10px;
    margin-left: 24rem;
    text-align: left;
  }

  .fontstyle{
    font-size: 20px;
    color:#006064;
  }

  .sidenav-header {
    /* background: url("../images/user-bg.jpg") no-repeat center center; */
    background-size: cover;
    margin-bottom: 0px;
    padding: 18px 0 0 18px;
    height: 64px;
      .row {
        margin-bottom: 0;
      }
    }

    .btntransparent{
      background-color: Transparent;
      background-repeat:no-repeat;
      border: none;
      cursor:pointer;
      overflow: hidden;
      outline:none;
      box-shadow: none!important;
      width:9rem;
      margin-left: -30px;
    }

    .nav-wrapper{
      /* background-color: #07657f ; */
      background-color: #2c5680 ;
    }

    .paddingTop{
      padding-top: 1.5rem !important;
    }

    .dropdown-content{
      width: 180px !important;
      overflow-y: hidden;
    }

    .textAlign{
      text-align: left;
    }

    .iconShift{
      margin:0px !important;
      padding: 0px 42px !important;
    }

    .left{
      text-align: left;
    }

    .footerstyle{
      position: absolute;
      top: calc(100vh - 57px);
    }

    svg {
      width: 100px;
      display: block;
      margin: 40px auto 0;
    }
    .path {
      stroke-dasharray: 1000;
      stroke-dashoffset: 0;
    }
    .path.circle {
      -webkit-animation: dash 0.9s ease-in-out;
      animation: dash 0.9s ease-in-out;
    }
    .path.line {
      stroke-dashoffset: 1000;
      -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
      animation: dash 0.9s 0.35s ease-in-out forwards;
    }
    .path.check {
      stroke-dashoffset: -100;
      -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
      animation: dash-check 0.9s 0.35s ease-in-out forwards;
    }
    p {
      text-align: center;
      margin: 20px 0 60px;
      font-size: 1.25em;
    }
    p.success {
      color: #73AF55;
    }
    p.error {
      color: #D06079;
    }
    @-webkit-keyframes dash {
      0% {
        stroke-dashoffset: 1000;
      }
      100% {
        stroke-dashoffset: 0;
      }
    }
    @keyframes dash {
      0% {
        stroke-dashoffset: 1000;
      }
      100% {
        stroke-dashoffset: 0;
      }
    }
    @-webkit-keyframes dash-check {
      0% {
        stroke-dashoffset: -100;
      }
      100% {
        stroke-dashoffset: 900;
      }
    }
    @keyframes dash-check {
      0% {
        stroke-dashoffset: -100;
      }
      100% {
        stroke-dashoffset: 900;
      }
    }

  @media only screen and (max-width : 992px) {
    header, main, footer {
      padding-left: 0 !important;
    }
    .headerTitle{
      padding-left: 0;
    }
    .mobileHeader{
      display: block;
      font-size: 18px;
      text-align: center;
    }
    .desktopHeader{
      display:none;
    }
    .paddingTop{
      padding-top: 0 !important;
    }
    .positioning{
      margin-left: 10px !important;
    }
    .fontstyle{
      font-size: 15px;
    }
  }
</style>
